import React from "react";
import Checkbox from "../../../../../shared/Checkbox/Checkbox";

const StatusCheckboxSelector = props => {
	const handleChange = event => {
		props.onChange({
			checkboxStatus: {
				toReceive: event[0].checked,
				canceled: event[1].checked,
				received: event[2].checked,
				resale: event[3].checked,
				suspended: event[4].checked,
			}
		});
	};

	const statusList = [
		{
			label: "A RECEBER",
			value: 1,
			checked: props.selecteds.toReceive
		},
		{
			label: "CANCELADO",
			value: 2,
			checked: props.selecteds.canceled
		},
		{
			label: "RECEBIDO",
			value: 3,
			checked: props.selecteds.received
		},
		{
			label: "REVENDA",
			value: 4,
			checked: props.selecteds.resale
		},
		{
			label: "SUSPENSO",
			value: 5,
			checked: props.selecteds.suspended
		}
	];

	return (
		<div>
			<h5>Escolha o status:</h5>
			<Checkbox
				onChange={handleChange}
				required={props.isRequired}
				options={statusList.map(status => ({
					label: status.label,
					value: status.value,
					checked: status.checked
				}))}
				data-action="status-checkbox-selector-status-choice-checkbox"
			/>
		</div>
	);
};

export default StatusCheckboxSelector;
